import { EEecsTransactionType, ETransactionStatus } from '../types/eecs-transaction.type';

export const EecsTransactionTypeMap = {
  [EEecsTransactionType.BUY]: {
    name: 'Buy',
    tooltip: '',
    styles: 'bg-appLightGreen text-black',
  },
  [EEecsTransactionType.SELL]: {
    name: 'Sell',
    tooltip: '',
    styles: 'bg-appLightBlue text-black',
  },
};

export const EecsTransactionStatusMap = {
  [ETransactionStatus.CANCELLED]: {
    name: 'Cancelled',
    tooltip: '',
    styles: 'bg-appRed text-black',
  },
  [ETransactionStatus.COMPLETED]: {
    name: 'Completed',
    tooltip: '',
    styles: 'bg-appLightGreen text-black',
  },
  [ETransactionStatus.PENDING]: {
    name: 'Pending',
    tooltip: '',
    styles: 'bg-appCreamy text-black',
  },
  [ETransactionStatus.NO_CONFIRMATION]: {
    name: 'No Confirmation',
    tooltip: '',
    styles: 'bg-appDirtySand text-black',
  },
  [ETransactionStatus.UNPAID]: {
    name: 'Unpaid',
    tooltip: '',
    styles: 'bg-appOrange text-black',
  },
};
